/**
 * Every user-facing string this surface owns.
 *
 * «What was not affected» carries more weight here than on the not-found page,
 * and more weight on a paid surface than on a public one: the fear a
 * subscriber arrives with is that something was half-done — a payment, a
 * renewal, a viewing position — so each is denied explicitly rather than
 * covered by a general reassurance.
 *
 * No status number, no error code, and no provider name appears below.
 */
export const serverErrorCopy = {
  documentTitle: 'حدث خلل من جانبنا — شاهدني',
  heading: 'حدث خلل من جانبنا',
  body: 'الخدمة لم تستجب لهذا الطلب. الخلل عندنا لا عندك: لم يتغيّر شيء في حسابك ولا في اشتراكك، ولم تُسجَّل أي عملية ولم يُخصم أي مبلغ، وموضع مشاهدتك محفوظ كما تركته.',

  actions: {
    retry: 'أعد المحاولة',
    home: 'عد إلى الرئيسية',
  },

  /**
   * A repeated fault is a defect report — a case type in the same queue, which
   * the subscriber raises themselves. This reader is signed in by definition,
   * so the entry is the case form directly rather than the public contact page
   * that serves an anonymous visitor on the other host.
   */
  report: {
    before: 'إن تكرّر الخلل، ',
    link: 'أبلغنا عنه',
    after: ' ونعالجه.',
  },
} as const;
